export default __webpack_public_path__ + "static/media/cs-training.7f356a48.png";